import { c as _c } from "react/compiler-runtime";
// The one segmented control. Variants: `track` (default; views, show, theme) — a track with the selected segment
// raised; `pills` (task status, the POC's approved look) — separate outlined pills, the selected one filled. Segments
// are toggle buttons (Segment) or links (NavLink children get aria-current from the router). A segment may carry a
// colour (`color`, e.g. a status colour: --seg-color) and data attributes for hooks (data-t, data-status).
// Styles: book.css `.seg`.
import type { CSSProperties, ReactNode } from "react";
export function Segmented({
  label,
  t,
  variant = "track",
  children
}: {
  label: string;
  t?: string;
  variant?: "track" | "pills";
  children: ReactNode;
}) {
  return <div className={variant === "pills" ? "seg pills" : "seg"} data-t={t} role="group" aria-label={label}>
			{children}
		</div>;
}
type SegmentProps = {
  pressed: boolean;
  onClick: () => void;
  color?: string;
  children: ReactNode;
} & Record<`data-${string}`, string | undefined>;
export function Segment(t0) {
  const $ = _c(14);
  let children;
  let color;
  let data;
  let onClick;
  let pressed;
  if ($[0] !== t0) {
    ({
      pressed,
      onClick,
      color,
      children,
      ...data
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = color;
    $[3] = data;
    $[4] = onClick;
    $[5] = pressed;
  } else {
    children = $[1];
    color = $[2];
    data = $[3];
    onClick = $[4];
    pressed = $[5];
  }
  let t1;
  if ($[6] !== color) {
    t1 = color ? {
      "--seg-color": color
    } as CSSProperties : undefined;
    $[6] = color;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== data || $[10] !== onClick || $[11] !== pressed || $[12] !== t1) {
    t2 = <button type="button" aria-pressed={pressed} onClick={onClick} style={t1} {...data}>{children}</button>;
    $[8] = children;
    $[9] = data;
    $[10] = onClick;
    $[11] = pressed;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}